import { ChangeDetectorRef, DestroyRef, inject, NgZone } from "@angular/core";

/** Listener global hors zone, handler rejoué dans la zone ; à poser panneau ouvert seulement. Renvoie le retrait. */
export function listenOutsideAngular(
  zone: NgZone,
  target: EventTarget,
  type: string,
  handler: (event: Event) => void,
  options?: boolean | AddEventListenerOptions,
): () => void {
  const listener = (event: Event) => zone.run(() => handler(event));
  zone.runOutsideAngular(() => target.addEventListener(type, listener, options));
  return () => target.removeEventListener(type, listener, options);
}

/**
 * Clic n'importe où dans la page, en capture : passe les stopPropagation (galet, dialogues) qui
 * empêchent un `@HostListener("document:click")` de voir le clic « à l'extérieur ».
 * Le handler ne rentre dans la zone que si `isActive()` (menu ouvert) : pas de détection de
 * changements à chaque clic pour chaque ligne de liste. Retiré à la destruction du composant.
 * À appeler dans un contexte d'injection (initialiseur de champ ou constructeur). Renvoie le retrait.
 */
export function onDocumentClickCapture(
  isActive: () => boolean,
  handler: (event: MouseEvent) => void,
  type: "click" | "contextmenu" = "click",
): () => void {
  const zone = inject(NgZone);
  const cdr = inject(ChangeDetectorRef);
  const listener = (event: Event) => {
    if (!isActive()) return;
    zone.run(() => {
      handler(event as MouseEvent);
      cdr.markForCheck();
    });
  };
  zone.runOutsideAngular(() => document.addEventListener(type, listener, true));
  const remove = () => document.removeEventListener(type, listener, true);
  inject(DestroyRef).onDestroy(remove);
  return remove;
}
